import AttachFileIcon from '@mui/icons-material/AttachFile'
import { Box, Button, Stack, Typography } from '@mui/material'
import { ChangeEvent, FC, RefObject } from 'react'

type CsvFileUploadSectionProps = Readonly<{
  fileInputRef: RefObject<HTMLInputElement>
  selectedFile: File | null
  onFileSelect: () => void
  onFileChange: (event: ChangeEvent<HTMLInputElement>) => void
}>

export const CsvFileUploadSection: FC<CsvFileUploadSectionProps> = ({
  fileInputRef,
  selectedFile,
  onFileSelect,
  onFileChange,
}) => {
  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1">CSVアップロード</Typography>
      <Typography variant="caption">
        ※削除用のCSVファイルを選択してください
      </Typography>
      <Box>
        <input
          type="file"
          ref={fileInputRef}
          onChange={onFileChange}
          accept=".csv,text/csv"
          style={{ display: 'none' }}
        />
        <Button
          size="medium"
          variant="contained"
          color="primary"
          onClick={onFileSelect}
        >
          CSVファイルを選択
        </Button>
      </Box>
      {selectedFile && (
        <Stack direction="row" spacing={1}>
          <Button
            size="medium"
            startIcon={<AttachFileIcon color="primary" />}
            onClick={onFileSelect}
          >
            <Typography variant="body2" color="primary">
              {selectedFile.name}
            </Typography>
          </Button>
        </Stack>
      )}
    </Stack>
  )
}
